import client from 'providers/fetchClient'

import { formatDocumentNumber } from 'utils/formatters'
import { translateBeneficiaryStatus } from 'utils/translators'

export const addBeneficiary = data => client.post('/beneficiaries', data)

export const addGroupOfBeneficiaries = data => client.post('/beneficiaries/csv', data)

export const getBeneficiary = id => client.get(`/beneficiaries/${id}`)

export const getBeneficiaries = async ({ search, sortBy, pagination, filters }) => {
  const params = { search, ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  const { data } = await client.get('/beneficiaries', { params })

  return {
    beneficiaries: data.data,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export const activateBeneficiary = (id, action) => client.put(`/beneficiaries/${id}/${action}`)

export const editBeneficiary = (id, data) => client.patch(`/beneficiaries/${id}`, data)

export const searchBeneficiaryByCpf = document => client.get(`/beneficiaries/cpf/${document}`)

export const fetchAll = async ({ search, sortBy, pagination, groupID, filters }) => {
  const params = { search, ...filters }

  if (sortBy && sortBy.length) {
    params.ordering = sortBy.map(({ id, desc }) => (desc ? `-${id}` : id)).join(',')
  }

  if (pagination) {
    params.page = pagination.currentPage
    params.limit = pagination.pageSize
  }

  if (groupID) {
    params.beneficiaries_group_id = groupID
  }

  const { data } = await client.get('/beneficiaries', { params })

  const beneficiaries = data.data.map(({ document, activation_day, groups, status, ...beneficiary }) => ({
    ...beneficiary,
    document: formatDocumentNumber(document),
    status: translateBeneficiaryStatus(status),
    groups: groups.length,
    activation_day: activation_day || '-',
    is_active: status === 'active',
  }))

  return {
    beneficiaries,
    pagination: {
      pageSize: data.limit,
      currentPage: data.page,
      totalPages: data.total_pages,
      totalRecords: data.total,
    },
  }
}

export default {
  fetchAll,
}
